import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/core/authentication/auth.service';

@Component({
  selector: 'app-education-history-section',
  templateUrl: './education-history-section.component.html',
  styleUrls: ['./education-history-section.component.scss'],
  standalone: false,
})
export class EducationHistorySectionComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private authService = inject(AuthService);

  workerId: number;
  isLoggedUserProfile: boolean;

  constructor() {}

  ngOnInit(): void {
    this.route.parent.data.subscribe((data) => {
      this.workerId = data['workerProfile'].WorkerId;
      this.isLoggedUserProfile = data['workerProfile'].AuthServerUserId === this.authService.authServerUserId;
    });
  }
}
